(function () {
  if (customElements.get('ce-filters-remove') !== undefined) {
    return;
  }

  class FiltersRemove extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        collection: 'ce-collection',
        button: '[data-filters-remove-button]',
      };

      this.elements = null;

      this.handleClickButton = this.handleClickButton.bind(this);
    }

    parsedCallback() {
      this.elements = {
        collection: document.querySelector(this.selectors.collection),
        button: this.querySelector(this.selectors.button),
      };

      this.elements.button.addEventListener('click', this.handleClickButton);
    }

    disconnectedCallback() {
      this.elements.button.removeEventListener('click', this.handleClickButton);
    }

    handleClickButton(event) {
      const url = event.target.closest(this.selectors.button).dataset.url;

      this.elements.collection.removeFilter(url);
    }
  }

  customElements.define('ce-filters-remove', FiltersRemove);
})();
